import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { FolderOpen } from "lucide-react";
import { api } from "@/lib/api";

export function DraftList() {
  const { data } = useQuery({ queryKey: ["imports", "list"], queryFn: () => api.get("/imports").then((r) => r.data.items) });
  if (!data?.length) return null;
  return (
    <section className="panel p-6" id="drafts" data-testid="import-drafts">
      <p className="eyebrow mb-4">Your import drafts</p>
      <ul className="divide-y divide-[#2A3447]">
        {data.map((d) => (
          <li key={d.draft_id} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`import-draft-${d.draft_id}`}>
            <div className="min-w-0">
              <p className="truncate text-sm text-slate-100">{d.set?.name || d.filename || (d.source === "paste" ? "Pasted import code" : "Import")}</p>
              <p className="font-mono text-xs text-slate-500">
                {d.summary.total} cards · {d.summary.finalized} imported · {d.summary.images_complete}/{d.summary.total} with images · {new Date(d.updated_at).toLocaleDateString()}
              </p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`rounded border px-2 py-0.5 font-mono text-[10px] uppercase ${d.status === "finalized" ? "border-aether-400/60 text-aether-300" : "border-amber-600/60 text-amber-300"}`}>
                {d.status === "finalized" ? "Finished" : "Draft"}
              </span>
              <Link to={`/import/${d.draft_id}`} className="btn-outline px-3 py-1.5 text-xs" data-testid={`import-draft-open-${d.draft_id}`}><FolderOpen className="h-3.5 w-3.5" />Open</Link>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
